<template>
  <div id="app">
    <AudioTranscoder />
  </div>
</template>

<script>
import AudioTranscoder from './AudioTranscoder.vue';

export default {
  name: 'App',
  components: {
    AudioTranscoder,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>